import { createFileRoute } from "@tanstack/react-router";

import { OrderPage } from "../../../../features/purchasing/order-page";

export const Route = createFileRoute("/_app/purchasing/orders/$id")({ component: Page });

function Page() {
  const { id } = Route.useParams();
  return <OrderPage key={id} id={id} />;
}
